/* ── Countdown Timer ── */
if (!customElements.get('flash-deals-timer')) {
  customElements.define(
    'flash-deals-timer',
    class FlashDealsTimer extends HTMLElement {
      connectedCallback() {
        this.autoDaily = this.dataset.autoDaily === 'true';
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        if (this.autoDaily) {
          this.getEndDate = () => {
            const nowUtc = Date.now();
            const turkeyOffset = 3 * 60 * 60 * 1000;
            const turkeyNow = new Date(nowUtc + turkeyOffset);
            const turkeyMidnight = new Date(Date.UTC(
              turkeyNow.getUTCFullYear(),
              turkeyNow.getUTCMonth(),
              turkeyNow.getUTCDate(),
              23, 59, 59
            ));
            return turkeyMidnight.getTime() - turkeyOffset;
          };
        } else {
          const endDate = new Date(this.dataset.endDate).getTime();
          if (isNaN(endDate)) return;
          this.getEndDate = () => endDate;
        }

        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        let diff = Math.max(0, this.getEndDate() - now);

        const totalHours = Math.floor(diff / 3600000);
        diff %= 3600000;
        const minutes = Math.floor(diff / 60000);
        diff %= 60000;
        const seconds = Math.floor(diff / 1000);

        this.hoursEl.textContent = String(totalHours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');

        if (!this.autoDaily && totalHours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(this.interval);
        }
      }
    }
  );
}

/* ── Product Slider ── */
if (!customElements.get('flash-deals-slider')) {
  customElements.define(
    'flash-deals-slider',
    class FlashDealsSlider extends HTMLElement {
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.fd__products-list',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };

        this.section = this.closest('.fd__products');
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);

        this.sliderInstance = false;
        this.init();
      }

      init() {
        if (typeof this.sliderInstance === 'object') return;

        const mobileColumns = parseInt(getComputedStyle(this).getPropertyValue('--fd-columns-mobile')) || 2;

        this.sliderOptions = {
          slidesPerView: mobileColumns + 0.15,
          spaceBetween: 10,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          breakpoints: {
            768: { slidesPerView: this.tabletItems, spaceBetween: 12 },
            1024: { slidesPerView: this.laptopItems, spaceBetween: 14 },
            1280: { slidesPerView: this.items, spaceBetween: 16 },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: { enabled: true, forceToAxis: true },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();
      }
    }
  );
}
